import React from 'react';
import ReactPlayer from 'react-player';
import { TUTORIAL_MENU_TYPE, tutorialMenuMap } from '@domain/constant/acca/tutorial/tutorialMenuType';
import classnames from 'classnames/bind';
import styles from './srInfo.module.scss';

const cx = classnames.bind(styles);

interface SrInfoProps {
  menu: TUTORIAL_MENU_TYPE;
  tabIndex: number;
}

const SrInfo = ({ menu, tabIndex }: SrInfoProps) => {
  const { title, desc, url } = tutorialMenuMap[menu].tabList[tabIndex];

  return (
    <div className={cx('infoArea')}>
      <div className={cx('videoWrap')}>
        <ReactPlayer url={url} muted={true} loop={true} playing={true} width={'100%'} height={'100%'} />
      </div>

      <div className={cx('infoWrap')}>
        <div className={cx('infoTitleArea')}>
          <strong className={cx('infoTitle')}>{title}</strong>
        </div>
        <p className={cx('infoText')}>{desc}</p>
      </div>
    </div>
  );
};

export default SrInfo;
